const FEEDBACK_DELAY = 2000;

/**
 * Copie hors contexte securise. L'API presse-papiers n'existe qu'en HTTPS et sur
 * localhost : sur un serveur de developpement joint par son IP, elle est absente.
 * La selection d'un champ hors ecran reste le seul recours, et elle fonctionne
 * partout ou la page s'affiche.
 */
const copyBySelection = (text: string): boolean => {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.setAttribute('aria-hidden', 'true');
    field.style.position = 'fixed';
    field.style.top = '-9999px';
    document.body.appendChild(field);
    field.select();

    let copied = false;
    try {
        copied = document.execCommand('copy');
    } catch {
        copied = false;
    }
    document.body.removeChild(field);
    return copied;
};

const copyText = async (text: string): Promise<boolean> => {
    if (window.isSecureContext && navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            // Refus de l'utilisateur ou permission absente : on tente l'autre voie.
        }
    }
    return copyBySelection(text);
};

/**
 * Bascule les deux icones et le message, tous deux rendus par le gabarit : rien
 * n'est construit ici, l'etat se limite a montrer l'un ou l'autre.
 */
const showFeedback = (button: HTMLElement, done: boolean): void => {
    button.querySelector('[data-copy-icon="idle"]')?.classList.toggle('hidden', done);
    button.querySelector('[data-copy-icon="done"]')?.classList.toggle('hidden', !done);

    const message = button.closest('[data-copy-block]')?.querySelector('[data-copy-message]');
    message?.classList.toggle('hidden', !done);
};

export const initCopyCode = (): void => {
    const buttons = document.querySelectorAll<HTMLButtonElement>('[data-copy-code]');
    if (!buttons.length) return;

    buttons.forEach((button) => {
        let reset: ReturnType<typeof setTimeout> | undefined;

        button.addEventListener('click', async () => {
            const source = button.closest('[data-copy-block]')?.querySelector<HTMLElement>('[data-copy-source]');
            if (!source) return;

            if (!(await copyText(source.innerText))) return;

            showFeedback(button, true);
            clearTimeout(reset);
            reset = setTimeout(() => showFeedback(button, false), FEEDBACK_DELAY);
        });
    });
};
